"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.permissionRoleLabels = exports.OrgPermissionRoles = exports.ProjectPermissionRoles = void 0;

var _permissionRoleLabels;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ProjectPermissionRoles;
exports.ProjectPermissionRoles = ProjectPermissionRoles;

(function (ProjectPermissionRoles) {
  ProjectPermissionRoles["PROJECT_PRIMARY_ADMIN"] = "PROJECT_PRIMARY_ADMIN";
  ProjectPermissionRoles["PROJECT_ADMIN"] = "PROJECT_ADMIN";
  ProjectPermissionRoles["PROJECT_CONTRIBUTOR"] = "PROJECT_CONTRIBUTOR";
  ProjectPermissionRoles["PROJECT_VIEWER"] = "PROJECT_VIEWER";
  ProjectPermissionRoles["SITE_MAINTENANCE"] = "SITE_MAINTENANCE";
})(ProjectPermissionRoles || (exports.ProjectPermissionRoles = ProjectPermissionRoles = {}));

var OrgPermissionRoles;
exports.OrgPermissionRoles = OrgPermissionRoles;

(function (OrgPermissionRoles) {
  OrgPermissionRoles["ORGANIZATION_ADMIN"] = "ORGANIZATION_ADMIN";
  OrgPermissionRoles["ORGANIZATION_USER"] = "ORGANIZATION_USER";
})(OrgPermissionRoles || (exports.OrgPermissionRoles = OrgPermissionRoles = {}));

var permissionRoleLabels = (_permissionRoleLabels = {}, _defineProperty(_permissionRoleLabels, OrgPermissionRoles.ORGANIZATION_ADMIN, 'Organization Admin'), _defineProperty(_permissionRoleLabels, OrgPermissionRoles.ORGANIZATION_USER, 'Organization User'), _defineProperty(_permissionRoleLabels, ProjectPermissionRoles.PROJECT_PRIMARY_ADMIN, 'Primary Site Admin'), _defineProperty(_permissionRoleLabels, ProjectPermissionRoles.PROJECT_ADMIN, 'Site Admin'), _defineProperty(_permissionRoleLabels, ProjectPermissionRoles.PROJECT_CONTRIBUTOR, 'Site Contributor'), _defineProperty(_permissionRoleLabels, ProjectPermissionRoles.PROJECT_VIEWER, 'Site Viewer'), _defineProperty(_permissionRoleLabels, ProjectPermissionRoles.SITE_MAINTENANCE, 'Site Maintenance'), _permissionRoleLabels);
exports.permissionRoleLabels = permissionRoleLabels;